import { Box, Grid, Typography } from '@mui/material';
import { Formik } from 'formik';
import React, { useEffect, useMemo, useState } from 'react';
import {
  ApplicationProps,
  IndividualAdditionalKYC,
  mdmsQuesAdditionKyc,
  individualMdmsQuestionsKyc,
} from '../../redux-store/types/api-types';
import {
  AdditionalKycDeclarationForbackgroundText,
  AdditionalKycDetails,
  AssignAnsAndVisibilityForInitialInvestorQuestion,
} from '../investors/additionalKYCDetails';
import { SubHeading } from '../investors/components';
import { checkAnsPresentKYC, getApplicantName } from '../../utils/utilityFunctions';
import { getInvestorAdditionalKycQues } from '../../redux-store/actions/application';
import { useDispatch } from 'react-redux';

export interface Values {
  applicants: {
    additional_kyc: IndividualAdditionalKYC[];
  }[];
  fundDeclaration: boolean;
  backgroundDeclaration: boolean;
  saveType: string;
}

export default function KycDetails({
  application = {},
}: {
  application: Partial<ApplicationProps>;
}): JSX.Element {
  const [kycDetails, setKycDetails] = useState<IndividualAdditionalKYC[]>([]);
  const dispatch = useDispatch();

  useEffect(() => {
    (async function () {
      try {
        const response = (await dispatch(
          getInvestorAdditionalKycQues()
        )) as unknown as mdmsQuesAdditionKyc;
        setKycDetails(response.investor_kyc_question_individual);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, []);

  const {
    applicants = [],
    fundDeclaration = false,
    backgroundDeclaration = false,
  } = application || {};
  const initialValues: any = useMemo(() => {
    return {
      applicants: applicants.map((applicant: any, applicantIndex: number) => {
        const { additional_kyc: existingInvestorprofile = null } = applicant || {};
        return {
          additional_kyc: existingInvestorprofile
            ? AssignAnsAndVisibilityForInitialInvestorQuestion(
                kycDetails.map((_kyc_Details: IndividualAdditionalKYC) => ({
                  ..._kyc_Details,
                  applicantIndex: applicantIndex,
                })),
                existingInvestorprofile,
                applicantIndex
              ).map((_kycDetails: IndividualAdditionalKYC) => ({
                ..._kycDetails,
                applicantIndex: applicantIndex,
              }))
            : kycDetails.map((_details) => ({ ..._details, applicantIndex: applicantIndex })),
        };
      }),
      fundDeclaration: fundDeclaration || false,
      backgroundDeclaration: backgroundDeclaration || false,
      saveType: 'save and proceed',
    };
  }, [application, kycDetails]);

  return (
    <Box
      sx={{
        bgcolor: 'white',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
        borderRadius: '10px',
      }}
      mt={5}>
      <Box sx={{ p: 2 }}>
        <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
          <Typography
            component="h2"
            sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main', mb: 3 }}>
            Additional Kyc Details
          </Typography>
          <Formik
            initialValues={initialValues as Values}
            enableReinitialize={true}
            onSubmit={() => {
              console.log('this action should not be trigered');
            }}>
            {({ values, setValues }) => (
              <Grid
                container
                rowSpacing={1}
                //columnSpacing={5}
                sx={{
                  width: '100%',
                  ml: 0,
                  '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
                }}>
                <>
                  {values?.applicants?.map((applicant, idx: number) => (
                    <>
                      <SubHeading
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                        }}>
                        Additional KYC Details of {getApplicantName(idx + 1, true)} Applicant
                      </SubHeading>
                      {!checkAnsPresentKYC(applicant.additional_kyc) ? (
                        <>
                          <Grid
                            xs={12}
                            sm={12}
                            sx={{
                              fontSize: 18,
                              fontWeight: 600,
                              color: 'common.black',
                              textAlign: 'center',
                              my: 3,
                            }}>
                            No Additional Kyc Details
                          </Grid>
                        </>
                      ) : (
                        <AdditionalKycDetails
                          data={applicant.additional_kyc as IndividualAdditionalKYC[]}
                          values={values}
                          setValues={setValues}
                          applicantIndex={idx}
                          disable={true}
                        />
                      )}
                      {/* {application.fundDeclaration && (
                        <Grid item xs={12} display="flex" alignItems={'flex-start'}>
                          <Typography
                            sx={{
                              fontSize: 15,
                              fontWeight: 700,
                              color: 'rgba(0, 0, 0, 0.6)',
                              letterSpacing: '0.5px',
                            }}>
                            {`I/We confirm that the funds transferred are sourced from my/our personal/business assets and/or from benefits of transactions due to me/us of which are known to me/us, more specifically, from (Please Select Source of Funds).`}
                          </Typography>
                        </Grid>
                      )}
                      {application.backgroundDeclaration && (
                        <Grid item xs={12}>
                          <Typography
                            sx={{
                              fontSize: 15,
                              fontWeight: 700,
                              color: 'rgba(0, 0, 0, 0.6)',
                              letterSpacing: '0.5px',
                            }}>
                            {`It is hereby declared and confirmed that:`}
                          </Typography>
                          <AdditionalKycDeclarationForbackgroundText />
                        </Grid>
                      )} */}
                    </>
                  ))}
                </>
              </Grid>
            )}
          </Formik>
        </Grid>
      </Box>
    </Box>
  );
}
